import * as React from 'react';
import bind from 'apmui/decorators/bind';
import Expandable from 'apmui/components/Expandable';
import ProgressAnimation from 'apmui/components/ProgressAnimation';
import OktaVerify from './OktaVerify';
import SmsEmailOption from './SmsEmailOption';
import { IOktaMfaModel, IOktaMfaEvent, Action } from './Model';

interface IOktaEnrollProps {
    okta: IOktaMfaModel;
    callback: (data: IOktaMfaEvent) => void;
}

interface IOktaEnrollState {
    step: number;
    enableBackBtn: boolean;
}

class OktaEnroll extends React.Component<IOktaEnrollProps, IOktaEnrollState> {
    state = {
        step: 1,
        enableBackBtn: true,
    };

    @bind
    onClick() {
        const { state } = this.props.okta.oktaMfa;
        if (!state.isMoreOption) {
            const linkSent: IOktaMfaEvent = {
                action: Action.UPDATE_STATE,
                name: 'linkSent',
                value: false,
            };
            this.props.callback(linkSent);
            const moreOptions: IOktaMfaEvent = {
                action: Action.UPDATE_STATE,
                name: 'isMoreOption',
                value: true,
            };
            this.props.callback(moreOptions);
            return;
        }
        if (this.state.step == 2) {
            this.setState({ step: 1 });
            this.showEnrollFactorsBtn(true);
            return;
        }
        this.showEnrollFactorsBtn(false);
        this.setState({ step: 2 });
    }
    @bind
    disableBackBtn() {
        this.setState({ enableBackBtn: false });
    }

    @bind
    showEnrollFactorsBtn(show: boolean) {
        const data: IOktaMfaEvent = {
            action: Action.UPDATE_STATE,
            name: 'showEnrollPageBtn',
            value: show,
        };
        this.props.callback(data);
    }

    render() {
        const centerAlign = { textAlign: 'center' as 'center' };
        const leftAlign = { textAlign: 'left' as 'left' };
        const { strings } = this.props.okta.oktaMfa;
        const rt = this.props.okta.oktaMfa.state;

        const renderQrCode = (code?: string) => {
            if (!code) {
                return <ProgressAnimation status="Loading" />;
            }
            return (
                <div style={centerAlign}>
                    <p style={leftAlign}>{strings.oktaVerifySetup}</p>
                    <img src={code} alt="QR code" />
                </div>
            );
        };

        const renderPush = () => {
            if (this.state.step === 1) {
                const qrCode = rt.hasEnrollInfo ? renderQrCode(rt.pushEnrollInfo.qrcode) : renderQrCode();
                return (
                    <div>
                        {qrCode}
                        <span className="button-container">
                            <input
                                type="submit"
                                className="apmui-button apmui-button-long"
                                id="okta_push.more_options"
                                value={strings.moreOptionsToEnroll}
                                onClick={this.onClick}
                            />
                        </span>
                    </div>
                );
            }
            const backBtn = this.state.enableBackBtn && (
                <span className="button-container">
                    <input
                        type="submit"
                        className="apmui-button apmui-button-long"
                        id="submit"
                        name="submit"
                        value={strings.back}
                        onClick={this.onClick}
                    />
                </span>
            );
            return (
                <div>
                    <SmsEmailOption
                        okta={this.props.okta}
                        callback={this.props.callback}
                        disableBackBtn={this.disableBackBtn}
                    />
                    {backBtn}
                </div>
            );
        };

        const renderOtp = () => {
            if (this.state.step === 1) {
                const qrCode = rt.hasEnrollInfo ? renderQrCode(rt.enrollInfo.qrcode) : renderQrCode();
                return (
                    <div>
                        {qrCode}
                        {rt.hasEnrollInfo && (
                            <Expandable caption={strings.moreOptionsToEnroll} captionClassName="apmui-link">
                                <p>{strings.oktaVerifyTotpSetup}</p>
                                <h3>{rt.enrollInfo.secret}</h3>
                            </Expandable>
                        )}
                        <span className="button-container">
                            <input
                                type="submit"
                                className="apmui-button apmui-button-submit apmui-button-long"
                                id="okta_totp.next"
                                value={strings.next}
                                onClick={this.onClick}
                            />
                        </span>
                    </div>
                );
            }
            return (
                <div>
                    <OktaVerify okta={this.props.okta} onClick={this.props.callback} />
                </div>
            );
        };
        return <div>{rt.isPush ? renderPush() : renderOtp()}</div>;
    }
}

export default OktaEnroll;
